import { QuickSwitch } from '@dealstack/frontend/shared/components/QuickSwitch/QuickSwitch';
import { Flex, FlexProps } from '@mantine/core';
import { Breadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/Breadcrumbs';

interface Props {
	showQuickSwitch?: boolean;
	showBreadcrumbs?: boolean;
	mantineFlexProps?: FlexProps;
}

export const QuickSwitchBreadcrumbsNav = ({
	showQuickSwitch = true,
	showBreadcrumbs = true,
	mantineFlexProps,
}: Props) => {
	return (
		<Flex gap="xs" align="center" {...mantineFlexProps}>
			{showQuickSwitch && <QuickSwitch />}
			{showBreadcrumbs && <Breadcrumbs />}
		</Flex>
	);
};
